import {HiOutlineMail} from 'react-icons/hi'
import { FaLinkedin } from "react-icons/fa"
import {FaWhatsapp} from 'react-icons/fa'
import { FaTwitter } from "react-icons/fa"
import {RiMessengerLine} from 'react-icons/ri'

const data = [
    {id: 1, icon: <HiOutlineMail/>, link: 'mailto:rrnomentafitasoa@gmail.com'},
    {id: 2, icon: <FaLinkedin/>, link: 'https://www.linkedin.com/in/tafitasoa-nomena-randriamampianina-71b66b245/message/'},
    {id: 3, icon: <FaWhatsapp/>, link: 'https://wa.me/+261341908424'},
    {id: 4, icon: <FaTwitter />, link: 'https://twitter.com/messages/compose?recipient_id=1616163713337147404'  },
    {id: 4, icon: <RiMessengerLine/>, link: 'https://www.messenger.com/t/100007865642661'},

]


// alternative whatsApp link
// https://wa.me/yournumber
// https://api.whatsapp.com/send/?phone=%2B233557097546


export default data